
import React from "react";
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
} from "@mui/material";
import DateRangePicker from "../inputs/DateRangePicker";
import CustomDatePicker from "../inputs/DatePickerInput";

export interface SidebarListProps {
  filterType?: string;
  options?: {
    id?: number;
    component?: React.ReactElement | undefined;
  }[];
}
const SidebarList = ({ filterType, options }: SidebarListProps) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  const [value, setValue] = React.useState<any>(null);
  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  return (
    <List
      sx={{ width: "100%", bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {filterType === "Date Range" ? (
        <React.Fragment>
          <ListItemText
            primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
            primary={"Choose Date Range"}
          />
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={(newDate) => setStartDate(newDate)}
            onEndDateChange={(newDate) => setEndDate(newDate)}
          />
        </React.Fragment>
      ) : filterType === "Input" ? (
        <ListItem style={{ display: "flex", flexDirection: "column" }}>
          {options &&
            options.map((option: any) => {
              return (
                <Stack m={1} width="100%">
                  {option.component}
                </Stack>
              );
            })}
        </ListItem>
      ) : (
        <React.Fragment>
          <ListItemButton onClick={handleClick}>
            <ListItemText
              primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
              primary={filterType}
            />
            {open ? (
              <i className="fal fa-chevron-down" />
            ) : (
              <i className="far fa-chevron-up" />
            )}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {options &&
                options.map((option: any) => {
                  return option.component;
                })}
            </List>
            {filterType === "Date" ? (
              <CustomDatePicker
                value={value}
                onChange={(newDate) => setValue(newDate)}
                placeholder="Start Date"
              />
            ) : null}
          </Collapse>
        </React.Fragment>
      )}
    </List>
  );
};
export default SidebarList;
